module.exports = __webpack_public_path__ + "static/media/icon-reload.1778495c.svg";